<form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>
        <h2 class="headline m-0 flex-auto">{{data.title}}</h2>
        <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
            <mat-icon svgIcon="mat:close"></mat-icon>
        </button>
    </div>
    <mat-divider class="text-border"></mat-divider>
    <mat-dialog-content class="flex flex-col">
        <mat-form-field class="flex-auto">
            <mat-label>Razón social</mat-label>
            <input formControlName="razonSocial" matInput>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Contacto</mat-label>
            <input formControlName="contacto" matInput>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Documento</mat-label>
            <input formControlName="documento" matInput>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Complemento</mat-label>
            <input formControlName="complemento" matInput>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Email</mat-label>
            <input formControlName="email" matInput type="email">
            <mat-error *ngIf="form.get('email').hasError('required')">El correo electrónico es obligatorio.</mat-error>
            <mat-error *ngIf="form.get('email').hasError('email')">Por favor, introduce un correo electrónico
                válido.</mat-error>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Celular</mat-label>
            <input formControlName="celular" matInput>
            <mat-error *ngIf="form.get('celular').hasError('required')">El celular es obligatorio.</mat-error>
            <mat-error *ngIf="form.get('celular').hasError('pattern')">El celular solo debe contener
                numeros.</mat-error>
            <mat-error *ngIf="form.get('celular').hasError('minlength')">El celular debe tener como minimo 8
                digitos.</mat-error>
        </mat-form-field>
        <mat-form-field class="flex-auto" *ngIf="operation === 2">
            <mat-label>Firebase Instance</mat-label>
            <input formControlName="firebaseInstance" matInput readonly="true">
        </mat-form-field>
        <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="4px">
            <mat-slide-toggle color="primary" labelPosition="before" formControlName="hasWhatsapp">Tiene Whatsapp?
            </mat-slide-toggle>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>
        <button [disabled]="form.invalid" color="primary" mat-flat-button type="submit">{{data.button}}</button>
    </mat-dialog-actions>
</form>